import { faChevronDown, faClose } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';

import { TrlNoDataFeedback, TrlStatusText } from '»components/atoms';

import { TrlListContent, TrlListTitle } from '../TrlList';
import {
  AccordionDetailsStyled,
  AccordionStyled,
  AccordionSummaryStyled,
  AccordionsWrapper,
  ArrowIcon,
  CloseIconStyled,
  HeaderStyled,
  SummaryItem,
} from './TrlAccordion.styles';

export const TrlAccordion = ({
  data,
  title,
  isModal,
  onCloseModal,
  hasMarginTop,
  isLoadingData,
}) => (
  <>
    <HeaderStyled hasMarginBottom={isModal}>
      <TrlListTitle
        title={title}
        hasBiggerTitle={isModal}
        hasMarginTop={hasMarginTop}
      />
      {isModal && <CloseIconStyled icon={faClose} onClick={onCloseModal} />}
    </HeaderStyled>

    {data.length === 0 && !isLoadingData && isModal ? (
      <TrlNoDataFeedback margin="0 0 23px" />
    ) : (
      <AccordionsWrapper id="listContainer">
        {data.map((item, index) => (
          <AccordionStyled
            key={item.id}
            defaultExpanded={isModal && index === 0}
          >
            <AccordionSummaryStyled
              expandIcon={<ArrowIcon icon={faChevronDown} />}
            >
              {item?.header.map((headerItem) => (
                <SummaryItem
                  key={headerItem.value}
                  nElements={item?.header.length}
                >
                  <TrlStatusText
                    value={headerItem.value}
                    type={headerItem.type}
                    color={headerItem.color}
                    textTransform={headerItem.textTransform}
                  />
                </SummaryItem>
              ))}
            </AccordionSummaryStyled>
            <AccordionDetailsStyled>
              <TrlListContent data={item?.content} noTopRadius />
            </AccordionDetailsStyled>
          </AccordionStyled>
        ))}
      </AccordionsWrapper>
    )}
  </>
);

TrlAccordion.propTypes = {
  data: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  isModal: PropTypes.bool,
  onCloseModal: PropTypes.func,
  hasMarginTop: PropTypes.bool,
  isLoadingData: PropTypes.bool,
};
